export const pageType = {
  DEFAULT: "DEFAULT", //只有一个全景图2-6
  DEFAULT_2: "DEFAULT_2", //只有一个平面图2-6
  DEFAULT_3: "DEFAULT_3", //只有一个平面图双目拼接 2-6
  TYPE_HANDLE_RIGHT: "TYPE_HANDLE_RIGHT", //左边全景图右边手柄2-7
  TYPE_SLIDE_DOWN: "TYPE_SLIDE_DOWN", //上方全景图下方滑块2-8
  TYPE_SLIDE_DOWN_2: "TYPE_SLIDE_DOWN_2", //上方平面图图下方滑块2-8
  TYPE_HANDLE_SLIDE_DOWN: "TYPE_HANDLE_SLIDE_DOWN", //上方全景图下方左滑块右手柄2-9
  TYPE_DOUBLE_HANDLE_SLIDE_DOWN: "TYPE_DOUBLE_HANDLE_SLIDE_DOWN", //上中都是全景图，下方左滑块右手柄2-10
  TYPE_DOUBLE_HANDLE_SLIDE_DOWN_2: "TYPE_DOUBLE_HANDLE_SLIDE_DOWN_2", //上平面图中全景图，下方左滑块右手柄2-10
  TYPE_DOUBLE_HANDLE_RIGHT: "TYPE_DOUBLE_HANDLE_RIGHT", //上全景图，下方左画面右手柄2-11
  TYPE_DOUBLE_HANDLE_RIGHT_2: "TYPE_DOUBLE_HANDLE_RIGHT_2", //上平面图，下方左全景图右手柄2-11
  TYPE_VIDEO: "TYPE_VIDEO", //只有一个视频2-12
  TYPE_THERMAL_IMG: "TYPE_THERMAL_IMG", //热成像，左右两个平面图 2-13
  TYPE_INSPECTION_INTRO:"TYPE_INSPECTION_INTRO" //巡课巡查系统介绍
};

//Math.PI 是180度
//每种预览类型对应的画中画数据的示例
export const previewInfo_TYPE_HANDLE_RIGHT = {
  viewerBoxCols: 8,
  viewerBoxRows: 4,
  viewerBoxPictureFile: "1-1-2-3769",
  moveTop: 90,
  moveBottom: -90,
  //向左120度
  moveLeft: -120,
  //向右120度
  moveRight: 120
}
//html 实例
export const html = "<div class='custom-maker-container' style='padding: 0px;'><div class='tooltipitem big' data-id='3769'><p class='tip-normal'>球机监控</p><p class='tip-preview'>预览画面</p></div><img src='https://media.tp-link.com.cn/webresource/act/vr/images/icon/point_white_yellow.png'  class='custom-maker-icon' /><div class='product-hover' style='top:1vw;left:0;width:100%;height:4vw'></div></div>"